//dependencies
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: Object.getOwnPropertyDescriptor(all, name).get
    });
}
_export(exports, {
    get GetCompanyReviewFormResponse () {
        return GetCompanyReviewFormResponse;
    },
    get GetCompanyReviewFormsResponse () {
        return GetCompanyReviewFormsResponse;
    },
    get PostCompanyReviewFormResponse () {
        return PostCompanyReviewFormResponse;
    }
});
const _bson = require("bson");
const _zod = require("zod");
const _models = require("@performyard/models");
const _utilsisomorphic = require("@performyard/utils-isomorphic");
const _reviewform = require("../review-form");
const PostCompanyReviewFormResponse = _zod.z.object({
    name: _zod.z.string(),
    _id: _zod.z.instanceof(_bson.ObjectID)
});
const GetCompanyReviewFormsResponse = _zod.z.object({
    forms: _zod.z.array(_reviewform.CompanyReviewFormModel),
    total: _zod.z.number().min(0),
    page: _zod.z.number().min(0),
    limit: _zod.z.number().min(0)
});
const GetCompanyReviewFormResponse = _reviewform.CompanyReviewFormModel.omit({
    questionsCount: true,
    relatedWorkflowCount: true,
    relatedWorkflows: true
}).extend({
    questions: _zod.z.array(_models.ReviewQuestionModel),
    createdAt: _utilsisomorphic.transformDateToUTCString.nullish(),
    creator: _zod.z.object({
        name: _zod.z.string().default(""),
        _id: _zod.z.instanceof(_bson.ObjectID).nullable().default(null)
    }).nullish(),
    goalDiscussion: _zod.z.boolean().optional().default(false),
    goalCreation: _zod.z.boolean().optional().default(false)
});
